import Footer from "../../footer"
import NavBar from "../../nav"

const SoftwareSolutions = () => {
  return <div className='software-solutions'>
    <NavBar />
    <div>
      <section className="clean-block pfa-content clearfix">
        <div className="divider sections">
          <h1>Compliance Solutions, LLC</h1>
          <div className="headline-divider sections"></div>
          <h2>Aviation Software Solutions</h2>
        </div>
      </section>
      <section className="grid-links-container row">
			<div className="container my-5">
				<div className="row">
					<div className="col-12 col-md-4 d-flex">
						<a href="/software/levelflight" className="grid-links grow text-center">
							<h3>LevelFlight</h3>
							<p>Compliance as a Service (CaaS) <br /> Subscription-based Compliance.</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex my-3 my-md-0">
						<a href="/software/electronic-flight-bag" className="grid-links grow text-center">
							<h3>Electronic Flight Bag</h3>
							<p>Fly Compliant Digital Solutions <br /> Paperless Operations in the Cloud.</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex">
						<a href="/software/electronic-recordkeeping" className="grid-links grow text-center">
							<h3>Electronic recordkeeping</h3>
							<p>Fly Compliant Digital Solutions <br /> One click access to paperless data.</p>
						</a>
					</div>
				</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default SoftwareSolutions